<template>
  <div>
    <a href="https://tucsonpathways.org"><div id="logo">Tp</div></a>
    <div id="backgroundart"></div>
    <div id="loginBody">
      <div class="banner">login</div>
      <form @submit.prevent="pressed">
        <br />
        <div class="blankLines">
          <input type="email" placeholder="email@address.com" v-model="email" />
        </div>
        <div class="blankLines">
          <input
            id="passUniqueID"
            type="password"
            placeholder="**********"
            v-model="password"
          />
        </div>
        <div class="togglePassword">
          <input type="checkbox" @click="togglePasswordVisibility" />
          <p>show password</p>
        </div>
        <br />
        <button type="submit" class="btn btn-warning">Login</button>
      </form>
      <div class="error" v-if="error">{{ error.message }}</div>
      <span
        >Need an account? Click here to
        <router-link to="/register">Register</router-link></span
      >
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  methods: {
    togglePasswordVisibility() {
      var x = document.getElementById("passUniqueID");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    async pressed() {
      try {
        // const val =
        await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password);
        // console.log(val);
        this.$router.replace({ name: "Map" }); //name: "Secret"
      } catch (err) {
        alert("Email/Password combo incorrect!");
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#logo {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  position: absolute;
  z-index: 3;
  max-width: 80px;
  max-height: 80px;
  left: 10px;
  background: #363636;
  width: 14vw;
  height: 14vw;
  font-size: 2.5em;
  line-height: 2.5em;
  color: white;
  text-align: center;
  font-family: auto;
  // box-shadow: 3px 3px 6px grey;
}

#backgroundart {
  z-index: -1;
  position: fixed;
  top: 0px;
  bottom: 0px;
  width: 100%;
  background-image: url("../assets/Background2.png");
  background-size: cover;
  // background-repeat: no-repeat;
  // background-attachment: fixed;
}

.togglePassword {
  > p {
    display: inline-block;
    margin-left: 10px;
    font-size: 0.75em;
  }
}

#loginBody {
  form {
    background: white;
  }

  .banner {
    color: #363636;
    text-shadow: 3px 3px 3px rgba(0, 0, 0, 0.50);
    font-size: 4em;
    margin: 5vh;
  }

  .btn.btn-warning {
    width: 150px;
    color: white;
    background-color: black;
    border: none;
    outline: none;
    border-radius: 0px;
  }

  font-family: Georgia, "Times New Roman", Times, serif;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 44px;
  text-align: center;

  @media (max-width: 812px) {
    > form {
      width: 80vw;
      margin: 3vh auto 5vh auto;
    }
  }

  @media (min-width: 812px) {
    > form {
      width: 50vw;
      margin: 5vh auto 5vh auto;
    }
  }

  > form {
    padding: 5vh 5vw;
    border: solid 1px grey;
    box-shadow: 6px 6px 6px rgba(0, 0, 0, 0.5);

    > .blankLines {
      margin: 20px;

      > input {
        text-align: center;
        border-top: none;
        border-right: none;
        border-left: none;
        border-bottom: solid 1px grey;
        width: 100%;
        outline: none;

        &:focus::-webkit-input-placeholder {
          color: transparent; //this removes the placeholder text "Your Email", when the input box is focused
        }

        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
      }
    }
  }

  > * {
    margin: 10px;
  }
}
</style>
